module.exports = __webpack_public_path__ + "static/media/Te.d61e1b93.svg";